import BootstrapTable from 'react-bootstrap-table-next';
import React from 'react';
import { Button, Dropdown } from 'react-bootstrap'
import { connect } from "react-redux";
import './../main.scss'
import './table.scss'
import Pagination from "react-js-pagination";
import checkJwt from './../../../Global/jwtChecker' 
import logout from './../../../Global/logout'
import GetTransactionList from './../../../API/Provider/GetTransactionList'
import { MdCancel } from 'react-icons/md'
import Modal from 'react-modal';
//import { store } from 'react-notifications-component';
import { withNamespaces } from 'react-i18next';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
//import loadingLogo from './../../../images/billy-logo.png'
import ButtonWithDropdown from '../../../Global/ButtonWithDropdown'
import { isMobile } from "react-device-detect";
import updateUser from '../../../API/Provider/PutUser'
import Loader from '../../../Global/loader';
import cancellationAPI from '../../../API/Provider/CreateTransaction'
import { ImFilePdf } from 'react-icons/im'
import { BsArrowDownUp } from 'react-icons/bs'
import getPDF from '../../../API/Provider/GetPdf.js'
import moment from 'moment'
import { store } from 'react-notifications-component';
import { AiOutlineSearch } from 'react-icons/ai'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css";
import hr from 'date-fns/locale/hr';
import ToExcel from './ToExcel'
import { RiFileExcel2Line } from 'react-icons/ri'
import GetTransactionListForExport from '../../../API/Provider/GetTransactionListForEport.js'
import { Row, Col, Form } from 'react-bootstrap'

export class TransactionsList extends React.Component{
  constructor(props) {
    super(props)

    this.state={
        searched: false,
        loading: true,
        showModal: false, 
        uuidForDelete: "",  
        deleteMessage: false, 
        comment: "",
        note: "",
        customStyles: {
            content : {
              top                   : '50%',
              left                  : '50%',
              right                 : 'auto',
              bottom                : 'auto',
              transform             : 'translate(-50%, -50%)',
              color: 'red',
              width                 : '400px'
            }
        },

        staticListSortBy: ["Amount",
            "Cancellation",
            "Country",
            "Country Code",
            "Created",
            "Currency",
            "Customer Id",
            "Customer Name", 
            "Sent",
            "Item Code",
            "Item Name",
            "Item Quantity", 
            "Note",
            "Payment Type",
            "Provider Name",
            "Date",
            "ID"
        ]
    }
}

    componentDidMount = async () => {
        //this.props.mapState("MAP_LOADING_CLIENT", true)
        this.setState({ loading: true })

        const unHashedJwt = await checkJwt()

        if(!unHashedJwt){
            logout()
        }

        this.getTransactionList()

        this.setState({ loading: false })
    }

    getTransactionList = async () =>{
        this.setState({ loading: true})
 
		const unHashedJwt = await checkJwt()

		if(!unHashedJwt){
			logout()
		}

		const list = await GetTransactionList(
            this.props.activePage,
            this.props.pageSize,
            this.props.sortBy.id,
            this.props.sortDirection,
            this.props.searchFor,
            this.props.dateFrom,
            this.props.dateTo
        )
 

		if(!list.error){
			await this.props.mapState("MAP_TRANSACTION_LIST", list.data.data.transactions)
            if(list.data.data.total_number_of_records > 0) {
                await this.props.mapState("MAP_TRANSACTION_TOTAL_NUMBER", list.data.data.total_number_of_records)
                //await this.props.mapState("CHANGE_IN_VAT_CLIENT_PARAMETERS", true)
            }
            else{
                await this.props.mapState("MAP_TRANSACTION_TOTAL_NUMBER", 0)
            }
		}
		else{
			logout()
		}
		
		// this.props.mapState("MAP_LOADING_CLIENT", false)
        //await this.props.mapState("MAP_LOADING_CLIENT", true)
        this.setState({ loading: false })
    };

    handleChange(e){
        this.props.mapState("MAP_TRANSACTION_SEARCH_FOR", e.target.value)
    }

    handlePageChange(pageNumber) {
		this.props.mapState("MAP_TRANSACTION_LIST_ACTIVE_PAGE", pageNumber)

		this.getTransactionList()
    }

    handleItemsPerPageChange(itemsPerPage) {
		this.setState({itemsPerPage: itemsPerPage});

		this.getTransactionList()
    }

    onItemsPerPageChange= async (size) =>{
        this.props.mapState("MAP_TRANSACTION_LIST_PAGE_SIZE", size)

        this.getTransactionList()
    }

    sortBy = async (data, index) => {
        this.props.mapState("CHANGE_SORTBY_CLIENT_PARAMETERS", {id: index, name: data})

        this.getTransactionList()
    }

    showModal = data => {
        this.setState({
            showModal: !this.state.showModal,
            dataForCancellation: data
        });
    };

    confirmCancellation = async () => {  
        await this.setState({
            loading: true,
            showModal: false
        })

        
        await cancellationAPI(this.state.dataForCancellation, this.state.note)
       
        this.componentDidMount();
        await this.setState({
            loading: false            
        });
    }

    mapComment = async (e) => {        
        this.setState({
            note: e.target.value
        }) 
    }

    donlowadPdf = async (data) => {
        await this.setState({
            loading: true            
        });
        const { t } = this.props;
        let pdf = await getPDF(data.uuid)
        if(pdf.data.status === 200){
            const blob = new Blob([pdf.data.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = `${data.customer_id}-${moment(data.created).format("DD.MM.YYYY")}.pdf`;
            await link.click();
        }
        else{
            store.addNotification({
                title: t('Error!'),
                message: t('Error retrieving PDF'),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                duration: 5000,
                pauseOnHover: true
                }
            });
        }

        await this.setState({
            loading: false            
        });
    }

    sortBy = async (data, index) => {
        this.props.mapState("CHANGE_SORTBY_TRANSACTION_PARAMETERS", {id: index, name: data})
        this.props.mapState("MAP_TRANSACTION_SORT_DIRECTION", data === "Created" ? 1 : 0)
        this.getTransactionList()
    }

    toggleSortDirection = async (data) => {
        this.setState({
            loading: true
        })
        
        await this.props.mapState("MAP_TRANSACTION_SORT_DIRECTION", data === 0 ? 1 : 0)
        
        await this.getTransactionList();
    }

    handleDateChange = async (e, field) => {
        e = e == null ? "" : e
        var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
        var localISOTime = (new Date(e - tzoffset)).toISOString();
        if(field === "dateFrom"){
            await this.props.mapState("MAP_TRANSACTION_DATE_FROM", e === "" ? "" : localISOTime) 
        }
        else{
            await this.props.mapState("MAP_TRANSACTION_DATE_TO", e === "" ? "" : localISOTime) 
        }       
    }

    saveAllToExcel= async () => {
        const list = await GetTransactionListForExport(
            this.props.activePage,
            this.props.pageSize,
            this.props.sortBy.id,
            this.props.sortDirection,
            this.props.searchFor,
            this.props.dateFrom,
            this.props.dateTo,
            true
        )

        await ToExcel(
            list.data.data.transactions, 
            this.props.dateFrom, 
            this.props.dateTo,
        )
    }

    triggerSearch = async () => {
        this.setState({ searched: true });
        this.getTransactionList();
    }


    render(){  
        const { t } = this.props  

        const columns = [{
            dataField: 'created',
            text: t('Created'),
            style: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.transaction.main.created,
            formatter: (cellContent, row) => {    
                return (                    
                    <span>
                        {moment(cellContent).format("DD.MM.YYYY")}
                    </span>
                );
            }
        }, {
            dataField: 'transaction_id',
            text: t('ID'),
            style: {wordWrap: "break-word"},
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.transaction_id
          },{
            dataField: 'customer_name',
            text: t('Customer Name'),
            style: {wordWrap: "break-word"},
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.customer_name
          }, {
            dataField: 'customer_id',
            text: t('Customer Id'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.customer_id
        }, {
            dataField: 'amount',
            text: t('Amount'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.amount
        },{
            dataField: 'currency_short',
            text: t('Currency'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.currency_short
        },{
            dataField: 'country',
            text: t('Country'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.country
        },{
            dataField: 'country_code',
            text: t('Conutry Code'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.country_code
        },{
            dataField: 'email',
            text: t('Email'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.email
        }, {
            dataField: 'item_code',
            text: t('Item Code'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.item_code
        },{
            dataField: 'item_name',
            text: t('Item Name'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },  
            hidden: this.props.user.user_web_properties.columns.transaction.main.item_name        
        }, {
            dataField: 'item_quantity',
            text: t('Item Quantity'),
            style: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.transaction.main.item_quantity   
        }, {
            dataField: 'payment_type',
            text: t('Payment'),
            style: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.transaction.main.payment_type   
        }, {
            dataField: 'jir',
            text: t('Fisc.'),
            style: {wordWrap: "break-word"} ,
            headerStyle: { wordWrap:  "break-word" },
            hidden: this.props.user.user_web_properties.columns.transaction.main.jir,
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} className={`${row.jir ? "color-green" : "color-red"}`}>
                        <strong>
                            { row.jir ?  t("Yes") : t("No") }
                        </strong>
                    </div>
                );
            }
        },{
            dataField: 'is_sent',
            text: t('Sent'),
            headerStyle: {wordWrap: "break-word"},
            hidden: this.props.user.user_web_properties.columns.transaction.main.is_sent,
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} className={`${row.is_sent ? "color-green" : "color-red"}`}>
                        <strong>
                            { row.is_sent ?  t("Yes") : t("No") }
                        </strong>
                    </div>
                );
            }
        }, {
            dataField: "sakriveno",
            text: '',
            isDummyField: true,
            style: {wordWrap: "break-word", width: '11.8em'},
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid}>
                        <Button
                            variant="success"
                            className="btnDetalji me-2"
                            onClick={() => this.donlowadPdf(row)}
                        >
                            <ImFilePdf /> {t("Details")}
                        </Button>
                        {row.cancellation === null &&
                            <Button
                                variant="danger"
                                className="btnIzbrisi"
                                onClick={() => this.showModal(row)}
                            >
                                <MdCancel /> {t("Delete")}
                            </Button>
                         }
                    </div>
                );
            }
          }     
        ]  
        
        /* Custom filter buttons */
        const CustomToggleList = ({ columns, onColumnToggle, toggles}, customFunkcija) => {
            //asiknrona funkcija za poziv default toggler funkcije + sprmenje promjene za poziv prema serveru
            customFunkcija = async (column) => {                
                await onColumnToggle(column.dataField)
                let data = { menu: "transaction", view: "main" , column: column.dataField }
                await this.props.mapState("USER_MAP_COLUMNS", data)
                await updateUser(
                    this.props.user,
                    this.props.user.provider_uuid
                )                
            }

            if(isMobile){
                return <Dropdown className="sortBy columnTogglerButton">
                    <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                    >
                        {t('Columns')}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    {columns
                        .filter(data => data.dataField !== "sakriveno")
                        .map(column => ({
                        ...column,
                        toggle: toggles[column.dataField]
                    }))
                    .map((column) => (
                            <Dropdown.Item
                                key = {column.dataField}
                                className={ ` ${column.toggle ? 'aktivan' : 'neaktivan'}` }
                                data-toggle="button" 
                                label={column.text}
                                id={column.dataField}
                                aria-pressed={(column.toggle) ? "true" : "false"}
                                onClick={() => customFunkcija(column) }
                            > 
                                {column.text}
                        </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown> 
            }

            else{
                return <div className="btn-group btn-group-toggle " data-toggle="buttons">
                {columns
                  .filter(data => data.dataField !== "sakriveno")
                  .map(column => ({
                    ...column,
                    toggle: toggles[column.dataField]
                  }))
                  .map((column) => (
                      <button                         
                          key = {column.dataField}
                          type="button" 
                          className={ ` ${column.toggle ? ' btn btn-success active' : 'btn btn-danger'}` }
                          data-toggle="button" 
                          label={column.text}
                          id={column.dataField}
                          aria-pressed={(column.toggle) ? "true" : "false"}
                          onClick={() => customFunkcija(column) }
                      >
                              {column.text}
                      </button>
                  ))}
              </div>
            }
        };       

	return(   
          this.state.loading ?
            <Loader />
          :
            <>
            <Row className="mt-4">
                <Col sm="12" xl="3">
                   <Form.Group as={Row} className="mb-3">
                        <Form.Label htmlFor="country" className="col-2 col-form-label">{t('Value')}</Form.Label>
                        <Col sm={10}>
                           <Form.Control
                                id="clientName"
                                type="text"
                                value={this.props.searchFor}
                                onChange={e => this.handleChange(e)}
                            />
                        </Col> 
                    </Form.Group>
                </Col>

                <Col sm="12" xl="4">
                   <Form.Group as={Row} className="mb-3">
                        <Form.Label htmlFor="country" className="col-2 col-form-label">{t('Date')}</Form.Label>
                        <Col sm={10} md={8}>
                            <DatePicker
                                selected={this.props.dateFrom !== ""  ? new Date(this.props.dateFrom) : ""}
                                onChange={date => this.handleDateChange(date, "dateFrom")}
                                startDate={new Date()}
                                locale={this.props.lng === "hr" ? hr : null}
                                dateFormat="dd.MM.yyyy"                                
                                maxDate={this.props.dateTo === "" ? new Date() : new Date(this.props.dateTo)}
                                className="date-picker"
                            />                                 
                        </Col>
                    </Form.Group>
                </Col>

                <Col sm="12" xl="4">
                   <Form.Group as={Row} className="mb-3">                       
                        <Col sm={10} md={8}>
                            <DatePicker
                                selected={this.props.dateTo !== ""  ? new Date(this.props.dateTo) : ""}
                                onChange={date => this.handleDateChange(date, "dateTo")}
                                //selectsStart
                                minDate={this.props.dateFrom === "" ? "" : new Date(this.props.dateFrom)}
                                locale={this.props.lng === "hr" ? hr : null}
                                dateFormat="dd.MM.yyyy"
                                maxDate={new Date()}
                                className="date-picker"
                            />                                 
                        </Col>
                    </Form.Group>
                </Col>
            
                <Col sm={12} xl={1}>
                    <div 
                        className="btn btn-light float-right"  
                        onClick={this.triggerSearch}
                    >
                        <AiOutlineSearch /> {t('Search')}
                    </div> 
                </Col>
            </Row>

            {this.props.totalNumber > 0 ?
            <>                
                <ToolkitProvider
                    keyField="transaction_id"
                    data={this.props.transactionList}
                    columns={columns}
                    columnToggle
                    prikaziSakrij = {this.prikaziSakrij}    
                    bodyStyle={{wordBreak: 'break-word'} }                         
                >
                    {(props) => (
                    <div className="mt-4">
                        <CustomToggleList {...props.columnToggleProps} />
                        <button
                            type="button" 
                            className="btn btn-light sort-direction-button"
                            data-toggle="button" 
                            label="sortBy"
                            id="sortBy"
                           // aria-pressed={(this.props.in_VAT) ? "true" : "false"}
                            onClick={() => this.toggleSortDirection(this.props.sortDirection) }
                        >
                            <BsArrowDownUp />
                        </button>
                        <ButtonWithDropdown 
                            itemsPerPage={this.state.staticListSortBy}
                            active={this.props.sortBy.name}
                            onItemsPerPageChange={this.sortBy}
                            className="sortBy sortBy-button"
                            toggleId="dropdown-basic"
                            style={{
                                float:"right",
                                width: "auto",
                                height: "30px"
                            }}     
                            toggleVariant="success"
                            itemDataToShow="name"    
                            t={this.props.t}  //language translation
                        />
                        { !isMobile ?
                            <hr />
                        : null }
                        <div className="table-responsive">
                            <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                        </div>
                    </div>
                    )}
                </ToolkitProvider>

                <div className="container mt-2">
                    <div className="row justify-content-md-center m-auto pt-2">      
                        <Col sm="2">
                            <ButtonWithDropdown 
                                itemsPerPage={[10, 20, 30, 50]}
                                active={this.props.pageSize}
                                onItemsPerPageChange={this.onItemsPerPageChange}
                                className="itemsPerPage"
                                toggleId="dropdown-basic"
                                styleToggle={{width:"auto"}}
                            />
                        </Col>
                        
                        <Col sm={8} className="text-center">
                            <Pagination
                                className="pagination"
                                firstPageText='1'
                                lastPageText={Math.ceil(
                                    this.props.totalNumber /
                                    this.props.pageSize
                                ).toString()}
                                hideDisabled
                                activePage={this.props.activePage}
                                itemsCountPerPage={this.props.pageSize}
                                totalItemsCount={this.props.totalNumber}
                                pageRangeDisplayed={5}
                                onChange={this.handlePageChange.bind(this)}  
                                itemClass="page-item"
                                linkClass="page-link"
                            />
                        </Col>

                        <Col sm={2}>
                            { this.props.dateFrom !== "" && this.props.dateTo !== "" && this.state.searched === true ?
                            <div 
                                className="btn btn-light float-right" 
                                onClick={() => this.saveAllToExcel()}
                            > 
                                <RiFileExcel2Line size={22}/> EXCEL 
                            </div>
                            : null }
                        </Col>
                    </div>
                </div>
            </>            
            :
                <div className="list-empty-container">
                    <h1>{t('Lista je prazna')}</h1>
                </div>
            }

           
            <Modal
                isOpen={this.state.showModal}                
                onRequestClose={() => this.showModal("")}
                style={this.state.customStyles}
            >
                <h3 className="modal-title">{t('Warning!')}</h3>
                    
                <div className=" p-2">
                    <p>
                        {t('Are you shure you want to cancel this transaction?')}  
                    </p>
                </div>
               
                <div className="p-2">
                    {t('Enter a comment')}:
                </div>
                
                <textarea rows="4" onChange={this.mapComment} className="webkit-fill-available">
                </textarea>

                <Row>
                    <Col sm="6">
                        <Button variant="primary" onClick={() => this.showModal("")}>{t('Close')}</Button>
                    </Col>
                    <Col sm="6">
                        <Button variant="danger" onClick={() => this.confirmCancellation()}>{t('Cancellation')}</Button>
                    </Col>                
                </Row>
            </Modal> 
        </>
    )}  
}

const mapStateToProps = state => {
  return {
        transactionList: state.transaction.transactionList,
        pageSize: state.transaction.pageSize,
        activePage: state.transaction.activePage,
        message: state.transaction.message,
        user: state.user,
        orderBy: state.transaction.orderBy,
        totalNumber: state.transaction.total_number,
        sortBy: state.transaction.sortBy,
        sortDirection: state.transaction.sortDirection,
        searchFor: state.transaction.serachFor,
        dateFrom: state.transaction.dateFrom,
        dateTo: state.transaction.dateTo
    };
};
  
const mapDispatchToProps = dispatch => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data}),
    API: (type, data) => dispatch({ type: type, data: data})
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces()(TransactionsList));
